// extracted by mini-css-extract-plugin
export default {"stock-list":"finance_stock-list_x","box-label":"finance_stock-list_box-label","section-label":"finance_stock-list_section-label"};